export const STAFF_NAV = [
    {
        key: 'home',
        label: 'Home',
        path: '/staff'
    },
    {
        key: 'general',
        label: 'General',
        tint: '#5A2929',
        groups: [
            {
                links: [
                    { path: '/staff/general/award-stamps', label: 'Award Framps' },
                    { path: '/staff/general/award-achievements', label: 'Award Achievements' },
                    { path: '/staff/general/appreciation', label: 'I Appreciate You' }
                ]
            }
        ]
    },
    {
        key: 'frankopop',
        label: 'FrankoPop',
        tint: '#8A6010',
        groups: [
            {
                links: [
                    { path: '/staff/frankopop/award', label: 'Award FrankoPop' }
                ]
            },
            {
                header: 'Admin',
                admin: true,
                links: [
                    { path: '/staff/frankopop/sets', label: 'Sets' },
                    { path: '/staff/frankopop/rarities', label: 'Rarities' },
                    { path: '/staff/frankopop/audit', label: 'Ledger & Audit' }
                ]
            }
        ]
    },
    {
        key: 'articles',
        label: 'Articles',
        tint: '#8A9A5B',
        groups: [
            {
                header: 'Writing',
                links: [
                    { path: '/staff/articles/new', label: 'New Article' },
                    { path: '/staff/articles/my-articles', label: 'My Articles' },
                    { path: '/staff/articles/new-observer', label: 'New Observer Issue' }
                ]
            },
            {
                header: 'Management',
                admin: true,
                links: [
                    { path: '/staff/articles/management', label: 'Article Management' },
                    { path: '/staff/articles/categories', label: 'Article Categories' }
                ]
            }
        ]
    },
    {
        key: 'values',
        label: 'Furni Values',
        tint: '#89CFF0',
        groups: [
            {
                links: [
                    { path: '/staff/values', label: 'Overview' },
                    { path: '/staff/values/furni', label: 'Furni Desk' },
                    { path: '/staff/values/categories', label: 'Categories' }
                ]
            }
        ]
    },
    {
        key: 'events',
        label: 'Events',
        tint: '#E8871E',
        groups: [
            {
                links: [
                    { path: '/staff/events', label: 'Schedule' },
                    { path: '/staff/events/stats', label: 'Statistics' }
                ]
            }
        ]
    },
    {
        key: 'moderation',
        label: 'Moderation',
        tint: '#8C2F2F',
        groups: [
            {
                links: [
                    { path: '/staff/moderation/profile-reports', label: 'Profile Reports' }
                ]
            }
        ]
    },
    {
        key: 'admin',
        label: 'Housekeeping',
        admin: true,
        wide: true,
        groups: [
            {
                header: 'Website Tools',
                links: [
                    { path: '/staff/admin/polls', label: 'Poll Management' },
                    { path: '/staff/admin/spotlight-articles', label: 'Spotlight Articles' },
                    { path: '/staff/admin/staff-team', label: 'Staff Team' },
                    { path: '/staff/admin/user-lookup', label: 'User Lookup' },
                    { path: '/staff/admin/users', label: 'User Management' },
                    { path: '/staff/admin/gdpr-delete', label: 'GDPR Delete' },
                    { path: '/staff/admin/banner-offsets', label: 'Banner Offsets' },
                    { path: '/staff/admin/imageupload', label: 'Image Upload' },
                    { path: '/staff/mailbox/send', label: 'Send FranklyMail' }
                ]
            },
            {
                header: 'Player Rewards',
                links: [
                    { path: '/staff/admin/manage-achievements', label: 'Manage Achievements' },
                    { path: '/staff/admin/remove-achievements', label: "Remove Player's Achievements" },
                    { path: '/staff/admin/skins', label: 'Profile Skins' },
                    { path: '/staff/admin/pfpbgs', label: 'PFP Backgrounds' }
                ]
            },
            {
                header: "Frank's Shack",
                links: [
                    { path: '/staff/admin/shop-items', label: 'Shop Items' },
                    { path: '/staff/admin/shop-discounts', label: 'Shop Discounts' },
                    { path: '/staff/admin/shop-purchases', label: 'Purchase Log' }
                ]
            },
            {
                header: 'Games',
                links: [
                    { path: '/staff/admin/slimespins', label: 'Slimeburger Spin' }
                ]
            },
            {
                header: 'AskFrank',
                links: [
                    { path: '/staff/admin/askfrank', label: 'Overview' },
                    { path: '/staff/admin/askfrank/sources', label: 'Sources' },
                    { path: '/staff/admin/askfrank/knowledge', label: 'Knowledge' },
                    { path: '/staff/admin/askfrank/frontpage', label: 'Front Page' },
                    { path: '/staff/admin/askfrank/lab', label: 'Lab' }
                ]
            },
            {
                header: 'Core Settings',
                links: [
                    { path: '/staff/admin/maintenance', label: 'Maintenance Mode' },
                    { path: '/staff/admin/features', label: 'Feature Switches' },
                    { path: '/staff/admin/themes', label: 'Site Themes' },
                    { path: '/staff/admin/sessions', label: 'Session Management' },
                    { path: '/staff/admin/cloud-upload', label: 'Toggle Upload Allowance', uploadMode: true },
                    { path: '/staff/admin/cloud-partners', label: 'FranklyCloud Partners' }
                ]
            }
        ]
    }
];

export function visibleStaffNav(userData) {
    const isAdmin = userData?.hasAdminRole === true;

    return STAFF_NAV
        .filter(item => !item.admin || isAdmin)
        .map(item => {
            if (!item.groups) return item;
            const groups = item.groups
                .filter(group => !group.admin || isAdmin)
                .map(group => ({ ...group, links: group.links.filter(link => !link.admin || isAdmin) }))
                .filter(group => group.links.length > 0);
            return { ...item, groups };
        })
        .filter(item => item.path || item.groups.length > 0);
}

export function activeStaffKey(pathname) {
    if (pathname === '/staff' || pathname === '/staff/') return 'home';
    if (pathname.startsWith('/staff/admin')) return 'admin';
    if (pathname.startsWith('/staff/general')) return 'general';
    if (pathname.startsWith('/staff/frankopop')) return 'frankopop';
    if (pathname.startsWith('/staff/articles')) return 'articles';
    if (pathname.startsWith('/staff/values')) return 'values';
    if (pathname.startsWith('/staff/events')) return 'events';
    if (pathname.startsWith('/staff/moderation')) return 'moderation';
    return '';
}
